export namespace ZhCn {
    export function factory() {
        return {
            header: {
                home: '首页',
                property: '推荐房源',
                blog: '我的博客',
            },
            footer: {
                admin: '管理员入口',
                copyright: '版权所有 © 2019 RIFO',
            },
            breadCrumb: {
                l1: '首页',
                l2_0: '我的博客',
                l2_1: '推荐房源',
                l3_0: '博客详情',
                l3_1: '房源详情',
            },
            blog: {
                read: '阅读',
                popTitle: '热门推荐',
                pop: '热门'
            },
            agentCard: {
                contact: '联系经纪',
                name: '姓名',
                phone: '电话',
                email: '电子邮件',
                date: '日期',
                morning: '上午',
                noon: '正午',
                afternoon: '下午',
                today: '今天',
                tomorrow: '明天',
                notes: '备注',
                submit: '提交',
                appointment: '预约看房'
            },
            propertyDetails: {
                title: '房源详情',
                propertySummary: {
                    community: '社区',
                    crossStreets: '交叉路口',
                    taxes: '地税',
                    maintFee: '管理费用',
                    monthPay: '月供'
                },
                cost: {
                    title: '购房费用',
                    '1': '转让税',
                    '2': '首套房',
                    '3': '非首套房',
                    '4': '房贷月供',
                    '5': '贷款总额',
                    '6': '首付',
                    '7': '月供',
                    '8': '20%首付，25年，5年浮动利率，2.25%年息',
                },
                desc: {
                    title: '房源描述'
                },
                schoolInfo: {
                    title: '学校信息',
                    titlePrimary: '小学 (JK - G8)',
                    titleSecondary: '中学 (G9 - G12)',
                    rankTitle: '菲莎排名(2019)'
                },
                roomsInfo: {
                    title: '房间详情',
                    roomsFields: {
                        name: '房间',
                        feet: '英尺',
                        meter: '米',
                        features: '细节描述'
                    },
                },
                disclaimer: {
                    title: '免责声明'
                },
                propertyMap: {
                    title: '地图',
                    showStreetView: '街景',
                    showMap: '地图'
                },
                summaryInfo: {
                    title: '房源简介',
                    fileds: {
                        id: '房源 ID',
                        zoning: '规划类型',
                        ownership: '分类所属',
                        propertyType: '房屋类别',
                        dom: '在市时间',
                        type: '交易类别',
                        city: '城市',
                        community: '社区',
                        garages: '车库',
                        parkings: '停车位',

                        lotArea: '占地面积',
                        usageArea: '使用面积',
                        buildingArea: '建筑面积',
                        apxAge: '房龄',
                        builtYear: '建筑年代',
                        maintFee: '维护费用',
                        frontOn: '朝向',
                        storeys: '楼层数',
                        occupancyDate: '入住日期',
                        brokerage: '地产公司'
                    }
                },
                detailInfo: {
                    title: '详情',
                    fileds: {
                        price: '挂牌价',
                        priceUnit: '价格单位',
                        fullAddress: '地址',
                        bedrooms: '卧室',
                        bedroomsPlus: '额外卧室',
                        washrooms: '浴室卫生间',
                        otherFee: '其他费用',
                        utilityIncludes: '设备包括',

                        utilityFeatures: '设备特点',
                        openHouse: '房源开放日',
                        tax: '地税',
                        condoFeatures: '公寓特点',
                        otherFeatures: '其他特点',
                        poolInfo: '泳池',
                        basements: '地下室',
                        crossStreets: '路口路段'
                    }
                },
                qrCode: {
                    wechatContent: '<p>扫一扫分享至微信</p>'
                }
            },
            propertyList: {
                title: '推荐房源',
                all: '更多房源'
            },
            blogList: {
                title: '我的博客',
                all: '更多博客'
            },
            aboutMe: {
                title: '关于我'
            },
            socialMedia: {
                '1': '转发分享'
            },
            contactForm: {
                '1': '姓名',
                '2': '电话号码',
                '3': '邮箱',
                '4': '备注',
            },
        };
    }
}
